import { apiRequest } from "./common";

const submitContactForm = async (data) => {
    const response = await apiRequest('post', `/contact-us/submit`, data);
    return response.data;
};

const CreateSubscriber = async (data) => {
    const response = await apiRequest('post', '/newsletter-subscriber', data);
    return response.data;
};

const getNewsLetter = async (pageNo, pagesize, searchText) => {
    const response = await apiRequest('get', `/newsletter-subscriber?page=${pageNo}&limit=${pagesize}&sort=desc${searchText !== '' ? `&search=${searchText}` : ''}`);
    return response.data;
};

const getExportNewsLetter = async () => {
    const response = await apiRequest('get', `/newsletter-subscriber/export`);
    return response.data;
};

const createStaticPage = async (data) => {
    const response = await apiRequest('post', `/static-page`, data);
    return response.data;
};

const updateStaticPage = async (id, data) => {
    const response = await apiRequest('put', `/static-page/${id}`, data);
    return response.data;
};

const getStaticPage = async (type) => {
    const response = await apiRequest('get', `/static-page/${type}`);
    return response.data;
};

const getStatics = async () => {
    const response = await apiRequest('post', `/admin/dashboard-statistics`);
    return response.data;
}

const getDashboardDetail = async () => {
    const response = await apiRequest('get', `/mentor/dashboard`);
    return response.data;
}

export {
    submitContactForm,
    CreateSubscriber,
    getNewsLetter,
    getExportNewsLetter,
    createStaticPage,
    updateStaticPage,
    getStaticPage,
    getStatics,
    getDashboardDetail
};
